import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { createAssignedBijlageForEntity } from '../services/createAssignedBijlageForEntity'

import { queryKey as queryKeyAssignedBijlagen } from './useAssignedBijlagenForEntity'

export { useCreateAssignedBijlageForEntity }

const useCreateAssignedBijlageForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: createAssignedBijlageForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyAssignedBijlagen] })
      successAlert('Bijlage successvol aangemaakt')
    },
  })
}
